<script setup lang="ts">
import HeaderComponent from "@/components/HeaderComponent.vue";
import BgLogo from "@/components/icons/BgLogo.vue";
import TheTabs from "@/components/TheTabs.vue";
import TheInfo from "@/components/TheInfo.vue";
import ThePayment from "@/components/ThePayment.vue";
import TheInstruction from "@/components/TheInstruction.vue";
import TheFaq from "@/components/TheFaq.vue";
import SteamCards from "@/components/SteamCards.vue";
import TheFooter from "@/components/TheFooter.vue";
import TelegramCard from "@/components/TelegramCard.vue";
import Modal from "@/components/Modal.vue";
import FileLogo from "@/assets/icons/file-text.svg";
import FaqLogo from "@/assets/icons/circle-question.svg";
import SteamIcon from "@/assets/icons/steam-icon.svg";
import { ref,watchEffect  } from 'vue'

const faq = ref(null)
const isModalOpen = ref(false);
const currentTab = ref('instruction');

const scrollToPromoFaq = () => {
  currentTab.value = 'faq';
  const lastIndex = faq.value.getLastIndex();
  faq.value.toggleFaq(lastIndex - 1, true);

}
watchEffect(() => {
  if (isModalOpen.value) {
    document.body.classList.add('overflow-hidden');
  } else {
    document.body.classList.remove('overflow-hidden');
  }
});
</script>
<template>
  <Modal v-if="isModalOpen" @modal-close="isModalOpen = false" :isModalOpen="isModalOpen"/>
  <HeaderComponent @show-modal="isModalOpen = true"/>
  <main class="rounded-t-3xl border-blue-light relative border-t pt-10 before:absolute before:top-2 before:w-[60px] before:bg-grey before:rounded-[20px] before:h-1.5 before:left-[calc(50%-30px)]">
    <div class="flex gap-x-3 items-start">
      <SteamIcon width="40" height="40"/>
      <div>
        <p class="text-[16px] text-black dark:text-white">Пополнение баланса Steam</p>
        <p class="text-[13px] text-black dark:text-white text-opacity-40">(для России и стран СНГ)</p>
      </div>
    </div>
    <TheTabs class="mt-3" />
    <p class="mt-2 text-[13px] text-black dark:text-white text-opacity-60">
      Если валюта в вашем Steam-аккаунте отличается, она будет автоматически
      сконвертирована
    </p>
    <ThePayment @call-faq-method="scrollToPromoFaq"/>
    <div class="mt-6 rounded bg-primary bg-opacity-10 dark:bg-blue-dark dark:bg-opacity-40 p-3">
      <div class="mb-6 grid grid-cols-2 gap-x-2 text-[13px]">
        <div class="">
          <input v-model="currentTab" id="tab_instruction" name="current_tab" type="radio" class="hidden peer" checked value="instruction">
          <label for="tab_instruction" class="flex items-center justify-center gap-x-2 text-center py-2 peer-checked:bg-primary peer-checked:text-white border-primary rounded border cursor-pointer text-black text-opacity-60 dark:text-white dark:text-opacity-60">
              <FileLogo width="16" height="16"/>
              Инструкция
          </label>
        </div>
        <div class="">
          <input v-model="currentTab" id="tab_faq" name="current_tab" type="radio" class="hidden peer" value="faq">
          <label for="tab_faq" class="flex items-center justify-center gap-x-2 text-center py-2 peer-checked:bg-primary peer-checked:text-white border-primary rounded border cursor-pointer text-black text-opacity-60 dark:text-white dark:text-opacity-60">
              <FaqLogo width="16" height="16"/>
              FAQ
          </label>
        </div>
      </div>
      <TheInstruction v-show="currentTab == 'instruction'"/>
      <TheFaq ref="faq" v-show="currentTab == 'faq'"/>
    </div>
    <SteamCards />
    <TelegramCard />
    <the-footer />
  </main>
</template>
